import styled from "styled-components";

export const StyledImageContainer = styled.div`
  max-width: 100%;
  height: auto;
  display: block;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;
